import { FC } from 'react';

import View from './view';

const UserReactivationRequestPage: FC = () => {
  return <View />;
};
export default UserReactivationRequestPage;
